export default __webpack_public_path__ + "static/media/642.86438990.jpg";